"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTypeEnum = void 0;
var PaymentTypeEnum;
(function (PaymentTypeEnum) {
    PaymentTypeEnum["EXPENSE_PAYMENT"] = "EXPENSE_PAYMENT";
    PaymentTypeEnum["WALLET_FUNDING"] = "WALLET_FUNDING";
})(PaymentTypeEnum || (exports.PaymentTypeEnum = PaymentTypeEnum = {}));
